import type { ClientHomePlanHydrated } from "api-types/homePlans/homePlanResponses";
import type { AnalyticsEventMetadata } from "lib/analytics";
import { sendAnalyticsEvent } from "lib/analytics";
import { useUserContext } from "lib/state/UserContextProvider";
import type { HomePlanEvent } from "./homePlanTypes";

const ANALYTICS_PRODUCT_NAME = "config";

export default function useHomePlanEvents(homePlan?: Partial<ClientHomePlanHydrated>) {
  const { builder } = useUserContext();

  return (eventName: HomePlanEvent, metadata: AnalyticsEventMetadata = {}) => {
    const params = {
      builder_id: builder?.id,
      builder_name: builder?.companyName,
      product: ANALYTICS_PRODUCT_NAME,
      home_plan_id: homePlan?.id,
      home_plan_name: homePlan?.planName,
      home_plan_status: homePlan?.planStatus,
      home_plan_category: homePlan?.category,
      home_plan_sales_agent_email: homePlan?.salesStaff?.email,
      home_plan_community_plan_id: homePlan?.communityPlanId,
      master_plan: homePlan?.masterPlanName,
      lot_id: homePlan?.lotId,
      lot_number: homePlan?.lot?.lotNumber,
      location_name: homePlan?.communityName,
      detached: !!homePlan?.detachedAt,
      ...metadata,
    };
    sendAnalyticsEvent(eventName, params);
  };
}
